
import { SupportApi, Configuration, ConfigurationParameters, SupportDTO } from "external-api/license-api";
import Cookies from "js-cookie";
import { trackPromise } from "react-promise-tracker";
import { CookieNames } from "utils/constants";
import { getToken } from "utils/cookieHelper";

import http from "./axiosService";
const apiUrl = `${process.env.REACT_APP_LICENSE_API_URL}`;

function getApi() {
    const token = getToken();
    const configParams: ConfigurationParameters = {
        basePath: apiUrl,
        baseOptions: {
            headers:
            {
                Authorization: `Bearer ${token}`
            }
        }
    };

    const axios = http.axios;
    const configuration = new Configuration(configParams);
    return new SupportApi(configuration, apiUrl, axios);
}

export default class SupportService {

    supportApi: SupportApi

    constructor() {
        this.supportApi = getApi();
    }

    submitSupportTicketAsync = async (supportRequest: SupportDTO) => {
        const resp = await trackPromise(this.supportApi.supportPost(supportRequest));
        return resp.data;
    }

}